import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=ba36319c&scoped=true&"
import script from "./NewsModal.vue?vue&type=script&lang=js&"
export * from "./NewsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba36319c",
  null
  
)

export default component.exports